const ADS_SEND_TO = "AW-18456358150/0a0PCODEivwcEIba1uBE";
const FIRED_KEY = "belov_tracked_leads_v1";

export function hasAnalyticsConsent() {
  try {
    return localStorage.getItem("cookie_consent") === "all";
  } catch (e) {
    return false;
  }
}

function alreadyTracked(leadId) {
  try {
    const list = JSON.parse(localStorage.getItem(FIRED_KEY) || "[]");
    if (list.includes(leadId)) return true;
    localStorage.setItem(FIRED_KEY, JSON.stringify([...list, leadId].slice(-50)));
    return false;
  } catch (e) {
    return false;
  }
}

// Fires once per successful lead, only with explicit consent. No PII is sent.
export function trackLeadSuccess({ leadId, serviceType }) {
  if (!leadId || typeof window.gtag !== "function" || !hasAnalyticsConsent()) return false;
  if (alreadyTracked(leadId)) return false;
  window.gtag("event", "generate_lead", { service_type: serviceType });
  window.gtag("event", "conversion", { send_to: ADS_SEND_TO, transaction_id: leadId });
  return true;
}
